import { render, staticRenderFns } from "./HomeWishlistBR.vue?vue&type=template&id=09e7a8c4&scoped=true"
import script from "./HomeWishlistBR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e7a8c4",
  null
  
)

export default component.exports